import React from 'react'
import { Box } from '@chatterbug/aaron'

const Empty = ({ children }) => {
  return (
    <Box
      bg="white100"
      p="3x"
      borderRadius="1x"
      borderWidth="medium"
      borderStyle="dashed"
      borderColor="gray88"
    >
      {children}
    </Box>
  )
}

export default Empty
